module.exports = __webpack_public_path__ + "img/Icon-25.08bb5d24.png";